import * as React from 'react';
import { cn } from '../../../libs/helpers/Utils';

interface ModalButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const ModalButton = ({ children, ...props }: ModalButtonProps) => {
  return (
    <button type="button" className={cn('btn', props.className)} {...props}>
      {children}
    </button>
  );
};
